import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12 col-xl-12" }
const _hoisted_3 = { class: "leads-details-tabs" }
const _hoisted_4 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "api_key-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing" }
const _hoisted_7 = { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-lg-12 mb-1" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "row mb-2" }
const _hoisted_16 = { class: "col-lg-12 mb-1" }
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  class: "tab-pane fade",
  id: "new_parcel-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_22 = { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_23 = { style: {"background":"#222","color":"#fff","border-radius":"6px","padding":"16px","font-family":"monospace","font-size":"15px"} }
const _hoisted_24 = { style: {"background":"transparent","color":"inherit","margin":"0","border":"none"} }
const _hoisted_25 = {
  class: "tab-pane fade",
  id: "tracking-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_26 = { class: "card mb-25 border-0 rounded-0 bg-white attachments-box" }
const _hoisted_27 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_28 = { style: {"background":"#222","color":"#fff","border-radius":"6px","padding":"16px","font-family":"monospace","font-size":"15px"} }
const _hoisted_29 = { style: {"background":"transparent","color":"inherit","margin":"0","border":"none"} }
const _hoisted_30 = { class: "mb-30 mt-5" }
const _hoisted_31 = {
  class: "tab-pane fade",
  id: "cities-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_32 = { class: "card mb-25 border-0 rounded-0 bg-white attachments-box" }
const _hoisted_33 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_34 = { style: {"background":"#222","color":"#fff","border-radius":"6px","padding":"16px","font-family":"monospace","font-size":"15px"} }
const _hoisted_35 = { style: {"background":"transparent","color":"inherit","margin":"0","border":"none"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("ul", {
          class: "nav nav-tabs border-0 mb-25",
          id: "myTab",
          role: "tablist"
        }, [
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 active",
              id: "api_key-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#api_key-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "api_key-tab-pane",
              "aria-selected": "true"
            }, " Génération API Key ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100",
              id: "new_parcel-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#new_parcel-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "new_parcel-tab-pane",
              "aria-selected": "false"
            }, " Nouveau Colis ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100",
              id: "tracking-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#tracking-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "tracking-tab-pane",
              "aria-selected": "false"
            }, " Synchroniser Statuts Colis ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100",
              id: "cities-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#cities-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "cities-tab-pane",
              "aria-selected": "false"
            }, " Liste des villes ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
                _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Génération API Key")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 lh-base" }, " Les accès fournis ci-dessous sont destinés à l'intégration de l'API. Ils vous permettent de connecter votre application à notre système et d'accéder à nos fonctionnalités. ", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("div", {
                  class: "alert alert-danger",
                  role: "alert"
                }, [
                  _createElementVNode("h3", { class: "alert-heading" }, [
                    _createElementVNode("i", { class: "ph-duotone ph-warning" }),
                    _createTextVNode(" Attention cher client !! ")
                  ]),
                  _createElementVNode("div", { class: "alert-body" }, [
                    _createElementVNode("span", null, "Attention à ne pas communiquer cette clé ou ces urls, afin de sécuriser votre compte et vos données")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "btn btn-primary float-end",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateApi && _ctx.generateApi(...args)))
                    }, _cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "flaticon-refresh" }, null, -1),
                      _createTextVNode(" Générer ma clé API ", -1)
                    ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label fw-bold" }, "Votre clé API :", -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          value: _ctx.keys.api_key,
                          disabled: "",
                          style: {"background-color":"#fff"}
                        }, null, 8, _hoisted_14),
                        _createElementVNode("button", {
                          class: "btn btn-outline-primary",
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipboard(_ctx.keys.api_key)))
                        }, _cache[4] || (_cache[4] = [
                          _createElementVNode("i", { class: "ph-duotone ph-copy" }, null, -1)
                        ]))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label fw-bold" }, "Votre ID :", -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          value: _ctx.keys.auth_key,
                          disabled: "",
                          style: {"background-color":"#fff"}
                        }, null, 8, _hoisted_19),
                        _createElementVNode("button", {
                          class: "btn btn-outline-primary",
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyToClipboard(_ctx.keys.auth_key)))
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "ph-duotone ph-copy" }, null, -1)
                        ]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
                _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Ajout d'un colis")
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("pre", _hoisted_24, "            " + _toDisplayString(_ctx.AddParcel) + "\n                ", 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mb-15 mb-md-20 mb-lg-25 d-sm-flex align-items-center justify-content-between" }, [
                  _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, " Modifier Statut d'un Colis ")
                ], -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("pre", _hoisted_29, "            " + _toDisplayString(_ctx.EditParcel) + "\n                ", 1)
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (row, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "rounded-pill fs-13 badge text-bg-black custom-badge me-2 mb-2",
                      style: _normalizeStyle([{"line-height":"30px"}, { '--dynamic-bg': row.code_color }])
                    }, _toDisplayString(row.code) + " => " + _toDisplayString(row.name), 5))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-15 mb-md-20 mb-lg-25 d-sm-flex align-items-center justify-content-between" }, [
                  _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, " La liste des villes de livraison ")
                ], -1)),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("pre", _hoisted_35, "                    " + _toDisplayString(_ctx.ApiCities) + "\n                ", 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}